/* global scriptsAjax:readonly, grecaptcha:readonly */

const $j = jQuery.noConflict();
const isProcessingClass = 'isProcessing';

function logToPHP(message) {
  let msg = message;

  if (typeof msg !== 'string') {
    msg = JSON.stringify(msg);
  }

  $j.ajax({
    type: 'POST',
    dataType: 'text',
    url: scriptsAjax.ajaxurl,
    data: {
      action: 'js_to_php_log',
      msg,
    },
    success(data) {
      if (data !== 'success') {
        // eslint-disable-next-line no-console
        console.error('failure writing to server log.');
      }
    },
    error(jqXHR, textStatus, errorThrown) {
      // eslint-disable-next-line no-console
      console.error(
        `ajax error writing to server log. (${textStatus})`,
        errorThrown,
      );
    },
  });
}

// allows async await for $.ajax
// tries to log to php on error
//
async function glsAjax(options) {
  const {
    url = scriptsAjax.ajaxurl,
    type = 'POST',
    dataType = 'json',
    data,
  } = options;

  try {
    return await $j.ajax({
      url,
      type,
      dataType,
      data,
    });
  } catch (err) {
    const errStr = (typeof err !== 'undefined')
      ? JSON.stringify(err)
      : '';

    logToPHP({
      where: 'scripts.js - glsAjax error',
      url,
      type,
      dataType,
      data: JSON.stringify(data),
      error: JSON.stringify(errStr),
    });
    throw new Error(`glsAjax error. ${JSON.stringify(err)}`);
  }
}

async function logTracking() {
  let response;

  try {
    response = await glsAjax({
      dataType: 'text',
      data: {
        action: 'log_tracking_to_console',
      },
    });
  } catch (err) {
    logToPHP(`LogTracking error. ${err}`);
    return;
  }

  if (response === 'tracking is off') {
    return;
  }

  // eslint-disable-next-line no-console
  console.log(response);
}

function isFormProcessing(submittingForm) {
  if (submittingForm.hasClass(isProcessingClass)) {
    return true;
  }

  return false;
}

function markFormProcessing(submittingForm, newState = null) {
  const currentState = submittingForm.hasClass(isProcessingClass);

  if (newState === null) {
    return;
  }

  if (newState && !currentState) {
    submittingForm.addClass(isProcessingClass);
  } else if (!newState && currentState) {
    submittingForm.removeClass(isProcessingClass);
  }
}

function feedback(feedbackParentContainer, msg, color = 'green') {
  // TODO
  // feedbackSlot.focus() for accessibility I think
  //
  const feedbackSlot = feedbackParentContainer.find('.feedbackSlot');
  let currentFeedback = feedbackSlot.html();

  if (currentFeedback.length !== 0) {
    currentFeedback += '<br />';
  }

  feedbackSlot.html(`${currentFeedback}<span style="color:${color};">${msg}</span>`);
}

function feedbackErr(feedbackParentContainer, msg) {
  feedback(feedbackParentContainer, msg, 'red');
}

function feedbackWarn(feedbackParentContainer, msg) {
  feedback(feedbackParentContainer, msg, 'orange');
}

function feedbackClear(feedbackParentContainer) {
  feedbackParentContainer.find('.feedbackSlot').html('');
}

// TODO
// consider something like this
// to replace the feedback functions above
// and search style.css for feedbackSlot
// because I think those styles are for this approach
//
function addFeedback(msg, isSuccess) {
  const feedbackEl = document.querySelector('#form-feedback');
  feedbackEl.style.display = 'block';
  const newDiv = document.createElement('div');
  const newDivWords = document.createTextNode(msg);
  newDiv.appendChild(newDivWords);
  newDiv.classList.add((isSuccess) ? 'success' : 'error');
  feedbackEl.appendChild(newDiv);
}

async function grecaptchaV3Execute(gaction) {
  try {
    // console.log('le token', token);
    const token = await grecaptcha.execute(scriptsAjax.grecaptchaV3SiteKey, { action: gaction });
    const response = await glsAjax({
      data: {
        action: 'evaluate_grecaptcha_v3_token',
        token,
        gaction,
      },
    });
    // console.log('le response', response);

    if (
      typeof response === 'undefined'
      || !response
      || $j.isEmptyObject(response)
    ) {
      return {
        success: false,
        action: gaction,
        'error-codes': ['gls-jquery-ajax-empty'],
      };
    }

    return response;
  } catch (err) {
    return {
      success: false,
      action: gaction,
      'error-codes': ['gls-jquery-ajax-fail'],
    };
  }
}

$j(() => {
  logTracking();

  // Google's recaptcha v3 will spaz
  // if the grecaptcha object isn't available
  // when the execute is required
  // so hide the form until it is
  //
  if (!$j('.showWhenGoogleIsReady').hasClass('googleIsNotReady')) {
    $j('.showWhenGoogleIsReady').addClass('googleIsNotReady');
  }

  if (typeof grecaptcha !== 'undefined') {
    grecaptcha.ready(() => {
      if ($j('.showWhenGoogleIsReady').hasClass('googleIsNotReady')) {
        $j('.showWhenGoogleIsReady').removeClass('googleIsNotReady');
      }
    });
  }

  $j('#thereIsJS').val('true');
});

export {
  logTracking,
  isFormProcessing,
  markFormProcessing,
  feedbackErr,
  feedbackWarn,
  feedback,
  feedbackClear,
  addFeedback,
  grecaptchaV3Execute,
  logToPHP,
  glsAjax,
};
